<template>
  <div class="pie-chart-wrap">
    <canvas ref="pieChart"></canvas>
  </div>
</template>

<script>
import { Chart } from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ChartDataLabels);

export default {
  props: [
    'totalAssets',
    'activeAssets',
    'inactiveAssets',
    'highTempAssets',
    'lowTempAssets',
    'lowBatteryAssets'
  ],
  mounted() {
    this.renderChart();
  },
  watch: {
    totalAssets: 'renderChart',
    activeAssets: 'renderChart',
    inactiveAssets: 'renderChart',
    highTempAssets: 'renderChart',
    lowTempAssets: 'renderChart',
    lowBatteryAssets: 'renderChart'
  },
  methods: {
    renderChart() {
      if (this.chart) {
        this.chart.destroy(); // 기존 차트를 제거하고 새로 생성
      }

      const ctx = this.$refs.pieChart.getContext('2d');
      this.chart = new Chart(ctx, {
        type: 'doughnut', // 도넛 차트로 설정
        data: {
          labels: ['Active', 'Inactive', 'High Temp', 'Low Temp', 'Low Battery'],
          datasets: [{
            data: [
              this.activeAssets,
              this.inactiveAssets,
              this.highTempAssets,
              this.lowTempAssets,
              this.lowBatteryAssets
            ],
            backgroundColor: ['#008000', '#ca1305', '#4a90e2', '#50e3c2', '#9013fe']
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'right' // 범례를 오른쪽에 배치
            },
            datalabels: {
              formatter: (value, context) => {
                const dataset = context.chart.data.datasets[0].data;
                const total = dataset.reduce((acc, val) => acc + val, 0);
                const percentage = ((value / total) * 100).toFixed(1); // 퍼센트 계산
                return percentage + '%'; // 퍼센트 표시
              },
              color: '#fff', // 텍스트 색상 설정
              font: {
                weight: 'bold'
              }
            }
          },
          cutout: '70%' // 가운데 비어있는 부분 크기 설정
        }
      });
    }
  }
};
</script>

<style scoped>
.pie-chart-wrap {
  width: 100%;
  height: 100%;
  min-height: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pie-chart-wrap canvas {
  max-width: 100%;
  max-height: 100%;
  display: block;
}
</style>
